import * as React from "react";
import { Loader2 } from "lucide-react";
import { cn } from "../lib/cn";

export interface SpinnerProps extends React.SVGAttributes<SVGSVGElement> {
  /** Optional visually-hidden label for screen readers. */
  label?: string;
}

export function Spinner({ className, label = "Loading", ...props }: SpinnerProps) {
  return (
    <span role="status" className="inline-flex items-center">
      <Loader2 className={cn("size-4 animate-spin text-muted-foreground", className)} {...props} />
      <span className="sr-only">{label}</span>
    </span>
  );
}
